export declare interface EventBus {

    constructor(description: string): EventBus

    on(type: string, listener: (event: Event) => void, replay: boolean): void
    on(type: string, listener: (event: Event) => void): void

    once(type: string, listener: (event: Event) => void): void

    off(type: string, listener: (event: Event) => void): void

    emit(type: string, data: any): boolean

}

const eventbus: EventBus = (window as any).eventbus as EventBus

export default eventbus